import ProductDescription from './ProductDescription'

const EggsProduct = {
  ...ProductDescription,
  category: '03',
  subCategory: '005',
  IsBroadband: true,
  ContainerSize: 'One dozen only',
  CASEFSCompliantCertification: false,
  EggShellColorCertification: false,
}

export default EggsProduct
